// src/App.js
import React, { useState } from "react";
import { motion } from "framer-motion";
import "./App.css";
import logo from "./cropbots-logo.png";
import About from "./components/About";
import Solutions from "./components/Solutions";
import Contact from "./components/Contact";
import Products from "./components/Products";

function App() {
  const [isDark, setIsDark] = useState(true);
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <div className={`App ${isDark ? "" : "light"}`}>
      <div className="navbar">
        <div className="navbar-left">
          <a href="#home" className="logo-link">
            <img src={logo} alt="CropBots Logo" className="logo-small" />
          </a>
          <h1 className="brand-name">CropBots</h1>
        </div>

        <div className={`navbar-center ${menuOpen ? "open" : ""}`}>
          <a href="#products" onClick={() => setMenuOpen(false)}>Products</a>
          <a href="#about" onClick={() => setMenuOpen(false)}>About</a>
          <a href="#contact" onClick={() => setMenuOpen(false)}>Contact</a>
        </div>

        <div className="navbar-right">
          <button className="theme-toggle" onClick={() => setIsDark(!isDark)}>
            {isDark ? "☀️ Light" : "🌙 Dark"}
          </button>
          <button className="menu-toggle" onClick={() => setMenuOpen(!menuOpen)}>
            ☰
          </button>
        </div>
      </div>

      {/* Hero Section */}
      <section id="home" className="hero">
        <motion.h2 initial={{ opacity: 0, y: -20 }} animate={{ opacity: 1, y: 0 }}>
          Welcome to CropBots
        </motion.h2>
        <motion.p
          className="description"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 1, duration: 1 }}
        >
          Smart robots for spraying, weed control, harvesting, and load carrying.
          Built for both indoor and field farming.
        </motion.p>
        <motion.a
          href="#contact"
          className="cta-button"
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
        >
          Contact Us
        </motion.a>
      </section>

      {/* Other Sections */}
      <About />
      <Products />
      <Solutions />
      <Contact />
    </div>
  );
}

export default App;
